import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { VOICES } from "@/data/content";

const reveal = {
  hidden: { opacity: 0, y: 36 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Testimonials = () => {
  return (
    <section id="voices" className="py-24 sm:py-32 lg:py-40 bg-paperdeep/60 border-y border-line" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20">
        <motion.p variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true }} custom={0} className="font-mono text-xs uppercase tracking-[0.24em] text-amber mb-6">
          Advance praise
        </motion.p>
        <motion.h2 variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true }} custom={1} className="font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-[1.15] max-w-2xl">
          What the room says <em className="text-wine">after the copy ships.</em>
        </motion.h2>
        <motion.p variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true }} custom={2} className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-subtle">
          Illustrative endorsements — references available on request
        </motion.p>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {VOICES.map((v, i) => (
            <motion.figure
              key={i}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              custom={i + 1}
              className={`bg-cream border border-line p-8 flex flex-col hover:-translate-y-1 hover:shadow-[0_24px_48px_-24px_rgba(26,24,21,0.35)] transition-[transform,box-shadow] duration-500 ${i === 1 ? "md:translate-y-8" : ""}`}
              data-testid={`testimonial-card-${i}`}
            >
              <Quote size={22} className="text-wine mb-6" />
              <blockquote className="font-serif text-lg leading-relaxed text-ink/90 flex-1">
                {v.quote}
              </blockquote>
              <figcaption className="mt-8 border-t border-line pt-5">
                <div className="font-mono text-xs uppercase tracking-[0.16em]">{v.name}</div>
                <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.14em] text-subtle">{v.org}</div>
                <div className="mt-2 font-mono text-[9px] uppercase tracking-[0.14em] text-amber">{v.mark}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
